module.exports = __webpack_public_path__ + "img/banner-1.9c93e043.jpg";